import Measure from 'react-measure';
import styled from 'styled-components';

import logo from './logo.svg';
import './App.css';
import { Alphabet } from './screens/Alphabet';
import { Numbers } from './screens/Numbers';
import { SimpleBoard } from './screens/SimpleBoard';
import backgroundImg from './assets/nc-pattern.png';
import PopItTextImg from './assets/pop-it-text.svg';
import FooterTextImg from './assets/footer-text.svg';
import BackArrow from './assets/back-arrow.svg';
import { useState } from 'react';

const Background = styled.div`
  background: url(${backgroundImg}) repeat fixed;
  background-size: 100px;
  opacity: 0.6;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: -99;
`;

const MainWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  padding: 10px;
  justify-content: center;
`;

const ContentWrapper = styled.div`
  //background-color: rgba(39, 43, 51, 0.4);
  flex: 1 0;
  display: flex;
  //width: 100%;
  flex-direction: column;
  //overflow: hidden;
`;

const PopItText = styled.img.attrs(() => ({
  src: PopItTextImg,
}))`
  height: 10vh;
  padding: 0 30px 10px 30px;
`;
const FooterText = styled.img.attrs(() => ({
  src: FooterTextImg,
}))`
  height: 10vh;
  padding: 0 30px 10px 30px;
`;

const BackButton = styled.img.attrs(() => ({
  src: BackArrow,
}))`
  height: max(10vh, 20px);
  padding: 0 30px 10px 30px;
  cursor: pointer;

  &:hover {
    filter: drop-shadow(2px 2px 2px black);
  }

  &:active {
    filter: blur(4px);
  }
`;

const HeaderWrapperx = styled.div`
  flex: 1;
  //background-color: rgba(95, 158, 161, 0.5);
  align-items: center;
  display: flex;
  justify-content: center;
`;
const BodyWrapperx = styled.div`
  flex: 8;
  //background-color: rgba(213, 183, 46, 0.5);
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
`;

const FooterWrapperx = styled.div`
  flex: 1;
  //background-color: rgba(95, 158, 161, 0.5);
  display: flex;
  justify-content: center;
`;

const MenuWrapper = styled.div`
  //background-color: rgba(213, 183, 46, 0.5);
  //width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const BoardLayout = ({ Component, goBack }) => {
  return (
    <ContentWrapper>
      <HeaderWrapperx>
        <BackButton onClick={goBack} />
        <PopItText />
      </HeaderWrapperx>

      <Measure bounds>
        {({ measureRef, contentRect }) => (
          <BodyWrapperx ref={measureRef}>
            <Component bounds={contentRect.bounds} />
          </BodyWrapperx>
        )}
      </Measure>

      <FooterWrapperx>
        <FooterText />
      </FooterWrapperx>
    </ContentWrapper>
  );
};

const MenuItem = styled.div`
  //flex: 1;
  //width: 120px;
  overflow: hidden;
  //height: 100%;
  //width: 100%;
  //border-style: solid;
  display: flex;
  justify-content: center;
  margin: 10px 0;
  //flex-direction: column;
  cursor: pointer;

  &:hover {
    filter: drop-shadow(8px 16px 16px black);
  }

  &:active {
    filter: blur(4px);
  }
`;

const OPTIONS = {
  MENU: 'MENU',
  ALPHABET: 'ALPHABET',
  NUMBERS: 'NUMBERS',
  SIMPLE: 'SIMPLE',
};

const Menu = ({ onClick }) => {
  return (
    <ContentWrapper>
      <HeaderWrapperx>
        <PopItText />
      </HeaderWrapperx>

      <MenuWrapper>
        <MenuItem onClick={() => onClick(OPTIONS.ALPHABET)}>
          <Alphabet bounds={{ width: 150, height: 200 }} interactive={false} />
        </MenuItem>
        <MenuItem onClick={() => onClick(OPTIONS.SIMPLE)}>
          <SimpleBoard bounds={{ width: 30, height: 160 }} interactive={false} />
        </MenuItem>
        <MenuItem onClick={() => onClick(OPTIONS.NUMBERS)}>
          <Numbers bounds={{ width: 150, height: 200 }} interactive={false} />
        </MenuItem>

        {/*{components.map((Component, i) => (*/}
        {/*  <Measure bounds key={i}>*/}
        {/*    {({ measureRef, contentRect }) => (*/}
        {/*      <MenuItem ref={measureRef}>*/}
        {/*        <Component bounds={contentRect.bounds} interactive={false} />*/}
        {/*      </MenuItem>*/}
        {/*    )}*/}
        {/*  </Measure>*/}
        {/*))}*/}

        {/*<MenuItem>*/}
        {/*    <Measure bounds>*/}
        {/*        {({ measureRef, contentRect }) => (*/}
        {/*            <div ref={measureRef} style={{ width: '100%', flex: 1, overflow: 'hidden' }}>*/}
        {/*                <Alphabet bounds={contentRect.bounds} />*/}
        {/*            </div>*/}
        {/*        )}*/}
        {/*    </Measure>*/}
        {/*</MenuItem>*/}
        {/*<MenuItem>*/}
        {/*    <Measure bounds>*/}
        {/*        {({ measureRef, contentRect }) => (*/}
        {/*            <div ref={measureRef} style={{ width: '100%', flex: 1, overflow: 'hidden' }}>*/}
        {/*                <Alphabet bounds={contentRect.bounds} />*/}
        {/*            </div>*/}
        {/*        )}*/}
        {/*    </Measure>*/}
        {/*</MenuItem>*/}
      </MenuWrapper>

      <FooterWrapperx>
        <FooterText />
      </FooterWrapperx>
    </ContentWrapper>
  );
};

function App() {
  const [step, setStep] = useState(OPTIONS.MENU);

  const handleGoBack = () => setStep(OPTIONS.MENU);

  return (
    <MainWrapper>
      {step === OPTIONS.MENU && <Menu onClick={setStep} />}
      {step === OPTIONS.SIMPLE && <BoardLayout Component={SimpleBoard} goBack={handleGoBack} />}
      {step === OPTIONS.ALPHABET && <BoardLayout Component={Alphabet} goBack={handleGoBack} />}
      {step === OPTIONS.NUMBERS && <BoardLayout Component={Numbers} goBack={handleGoBack} />}
      <Background />
    </MainWrapper>
  );
}

export default App;
